// AI探索境界: docs/design/foundation/responsibility/shopify-theme-boundary-map.md
// venue-cart コレクション（main-collection-product-grid-cart セクション）限定。
// utm-tracker.js はカート属性への反映のみで商品ページURL自体は書き換えないため、
// このスクリプトは商品カードの遷移先URLに直接 UTM クエリを埋め込み、
// localStorage が失効した場合でも商品ページ側でUTMを読み取れるようにする。
(function () {
  var UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

  function getUtmObj() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    var found = false;
    UTM_KEYS.forEach(function (key) {
      var value = params.get(key) || localStorage.getItem(key);
      if (value) {
        utm[key] = value;
        found = true;
      }
    });
    return found ? utm : null;
  }

  function appendUtmToLink(link, utm) {
    if (!link.href) return;
    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    Object.keys(utm).forEach(function (key) {
      url.searchParams.set(key, utm[key]);
    });
    link.href = url.toString();
  }

  function rewriteProductLinks(root, utm) {
    var links = root.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (link) {
      appendUtmToLink(link, utm);
    });
  }

  function init() {
    var container = document.getElementById("ProductGridContainer");
    if (!container) return;

    var utm = getUtmObj();
    if (!utm) return;

    rewriteProductLinks(container, utm);

    // load-more / infinite-scroll で追加される商品カードにも同じ変換を適用する
    var observer = new MutationObserver(function () {
      rewriteProductLinks(container, utm);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
